module.exports = __webpack_public_path__ + "img/linkedin.2e89d06e.svg";